import { EnumTripChannelCode, PinCodeInstruction } from '@src/types/api/models';
import { PinCode } from '@src/types/api/models/pin-code';

export const getPinCode = (instruction: PinCodeInstruction, pinCodes: PinCode[]) => {
  if (!instruction.type) {
    return undefined;
  }

  if (instruction.type === 'static') {
    return instruction.pinCode;
  }

  return pinCodes.find(({ title }) => `{{reservation.${title}}}` === instruction.pinCodeKey)?.code;
};

export const translatedChannelCode: Record<string, string> = {
  BookingCom: 'Booking.com',
} as Partial<Record<EnumTripChannelCode, string>>;
